import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

import { FORTA_BLUE, FORTA_GRAY4 } from '../../utils/colors';

import type { TooltipProps } from '@mui/material';

interface FHTooltipProps extends TooltipProps {
  tooltipBorder?: string;
  tooltipBorderRadius?: string;
  tooltipBoxShadow?: string;
  tooltipbackground?: string;
  maxwidth?: number;
}

const StyledToolTip = styled(
  ({
    className,
    tooltipbackground: _tooltipbackground,
    maxwidth: _maxwidth,
    tooltipBorder: _tooltipBorder,
    tooltipBorderRadius: _tooltipBorderRadius,
    tooltipBoxShadow: _tooltipBoxShadow,
    ...props
  }: FHTooltipProps) => <Tooltip {...props} classes={{ popper: className }} />,
)(({
  tooltipbackground,
  maxwidth,
  tooltipBorder,
  tooltipBorderRadius,
  tooltipBoxShadow,
  sx = {},
}) => {
  return {
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: maxwidth ?? 'auto',
      fontSize: '16px',
      fontWeight: 400,
      backgroundColor: tooltipbackground ?? FORTA_BLUE.light3,
      border: tooltipBorder ?? 'none',
      borderRadius: tooltipBorderRadius ?? '0px',
      boxShadow: tooltipBoxShadow ?? 'none',
      color: FORTA_GRAY4,
      padding: '5px 8px',
      ...sx,
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: tooltipbackground ?? FORTA_BLUE.light3,
    },
  };
});

const FHTooltip = (props: FHTooltipProps) => {
  const { children, ...rest } = props;

  return <StyledToolTip {...rest}>{children}</StyledToolTip>;
};

export default FHTooltip;
